var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { matchPath } from "react-router-dom";
export var getProtocal = function (loc) {
    // Protocol may or may not contain a colon
    var protocol = loc.protocol;
    if (protocol.slice(-1) !== ":") {
        protocol += ":";
    }
    return protocol;
};
export var getPath = function (loc) {
    var _loc = window.location;
    var protocol = getProtocal(_loc);
    return protocol + "//" + _loc.host + loc.pathname;
};
export var getFullPath = function (loc) {
    var windowLoc = window.location;
    return getProtocal(windowLoc) + "//" + windowLoc.host + loc.pathname + loc.search + loc.hash;
};
export var getPropsPageView = function (props) { return (__assign({}, props)); };
export var getLocationFromString = function (href) {
    var l = document.createElement("a");
    l.href = href;
    return l;
};
export var getPreviousFullPath = function (prevLoc, currentLoc) {
    var previousFullPath = null;
    if (!prevLoc) {
        if (!document.referrer) {
            previousFullPath = getFullPath(currentLoc);
        }
        else {
            previousFullPath = document.referrer;
        }
    }
    else {
        previousFullPath = getFullPath(prevLoc);
    }
    return previousFullPath;
};
export var getMatchRoute = function (path, routes) {
    var pathname = getLocationFromString(path).pathname;
    var matches = routes
        .map(function (route) {
        return { match: matchPath(pathname, route), route: route };
    })
        .filter(function (_a) {
        var match = _a.match;
        return !!match;
    });
    if (matches && matches.length !== 0) {
        var _a = matches[0], match = _a.match, route = _a.route;
        var others = route.parser ? route.parser(path, match) : {};
        return __assign(__assign({}, route), others);
    }
    return {};
};
//# sourceMappingURL=common.js.map